<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/12CH/12CH.jpg" alt="12CH DSP Amplifier">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">12CH DSP Amplifier</div>
                <div class="detail-banner-desc">
                    It uses advanced DSP tech for Hi-Fi sound reproduction;<br />
                    The product supports rich audio features including stereo, 2D virtual surround, multiple EQ modes, in-car engine sound simulation (iESE), engine active noise cancellation (ENAC), dynamic noise compensation (DNC), and etc.
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>
                    <div class="detail-desc">
                        <div>
                            Self developed, complete R&D team, mature and reliable SOP solutions.<br />
                        </div>
                        <div>
                            620W rated output power, 12CH audio outputs, drive up to 17 speakers.<br />
                        </div>
                        <div>
                            High computing power, rich audio processing.
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/12CH/12CH-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">198*150*40</div>
                                    <div class="k">Size(mm)</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1140</div>
                                    <div class="k">Weight(g)</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">620W</div>
                                    <div class="k">Rated Power</div>
                                </div> 
                                <div class="spec-item">
                                    <div class="v">&gt85dB</div>
                                    <div class="k">SNR</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">&lt0.1%</div>
                                    <div class="k">THD+N</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Stereo sound, Amor TruLogic® 2D surround, and a variety of audio experience models</div>
                                    <div class="k">Audio Function</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">iESE simulates sound waves, ENAC engine noise reduction, and DNC dynamic speed compensation</div>
                                    <div class="k">Audio Function</div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/12CH/12CH-1.jpg" alt="200-1-02">
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: '12CH DSP Amplifier - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/electronics/12CH.html'

};

import { createApp } from 'vue';
import App from './12CH.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./12CH.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
